import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 2L2 8L13.38 10.62L16 22L22 2ZM14.46 8.83L9.8 7.75L18 5.29L14.46 8.83ZM17.64 9.57L15.61 9.1L18.71 6L17.64 9.58V9.57ZM16.25 14.19L15.51 11.12L17.06 11.48L16.25 14.19Z" fill={ fill || 'currentColor' } />
    </svg>
);
